import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  ShieldCheck, // For Durability
  Palette, // For Customization
  Leaf, // For Eco-Friendly
  GripHorizontal // For Twisted Handles
} from 'lucide-react';

const ProductCategory2 = () => {
  const features = [
    {
      icon: ShieldCheck,
      title: "Durable",
      description: "Designed with sturdy paper to carry light to moderately heavy items securely.",
      bgColor: "#4CAF50" // Green for durability
    },
    {
      icon: Palette,
      title: "Customizable",
      description: "Smooth surface perfect for printing logos, designs, or promotional messages.",
      bgColor: "#FF9800" // Orange for customization
    },
    {
      icon: Leaf,
      title: "Eco-Friendly",
      description: "Made from recyclable and biodegradable materials, promoting sustainability.",
      bgColor: "#2196F3" // Blue for eco-friendly
    },
    {
      icon: GripHorizontal,
      title: "Twisted Handles",
      description: "Strong and stylish handles provide a comfortable grip for everyday use.",
      bgColor: "#9C27B0" // Purple for handles
    }
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
        <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
          White paper bags with an eco-friendly and easy-to-open design, durable construction, and a flat square bottom, offering sustainable and stylish packaging solutions.
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.bgColor }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;